module.exports = __webpack_public_path__ + "img/bus-station-purple.251d3953.svg";